var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/finance/ProfitCenterEnums';
let ProfitCenterModule = class ProfitCenterModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.loadPage = false;
        // api profit
        this.profitCenterList = [];
        this.page = 1;
        this.size = 10;
        this.pageFilter = 1;
        this.wasLoadQuickFilter = true;
        this.desc = '';
        this.searchBy = '';
        this.paging = [];
        this.status = '';
        this.statusMessage = '';
        this.selectedProfitCenter = [];
        this.selectingProfitCenter = true;
        this.checkedProfitCenter = [];
        this.dropdownlistProfitCenter = [];
    }
    get getDropdownlistProfitCenter() {
        return this.dropdownlistProfitCenter;
    }
    get getProfitCenterLists() {
        return this.profitCenterList;
    }
    get getProfitCenterStatus() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getSelectedProfitCenter() {
        return this.selectedProfitCenter;
    }
    get getSelectingProfitCenter() {
        return this.selectingProfitCenter;
    }
    get getProfitCenterPaging() {
        return this.paging;
    }
    get getProfitCenterLoading() {
        return this.loading;
    }
    get getStatusProfitCenter() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getProfitCenterSize() {
        return this.size;
    }
    get getCheckedProfitCenter() {
        return this.checkedProfitCenter;
    }
    get getProfitCenterWasLoadQuickFilter() {
        return this.wasLoadQuickFilter;
    }
    get getProfitCenterDesc() {
        return this.desc;
    }
    get getProfitCenterSearchBy() {
        return this.searchBy;
    }
    [_a = Mutations.SET_SELECTED_PROFIT_CENTER](payload) {
        this.selectedProfitCenter = payload;
    }
    [_b = Mutations.SET_SELECTING_PROFIT_CENTER](payload) {
        this.selectingProfitCenter = payload;
    }
    [_c = Mutations.SET_CHECKED_PROFIT_CENTER](payload) {
        this.checkedProfitCenter = payload;
    }
    [_d = Mutations.SET_PROFIT_CENTER_LIST](payload) {
        this.profitCenterList = payload;
    }
    [_e = Mutations.SET_PROFIT_CENTER_LOADING](payload) {
        this.loading = payload;
    }
    [_f = Mutations.SET_PROFIT_CENTER_HANDLE_PAGE](payload) {
        this.page = payload;
    }
    [_g = Mutations.SET_PROFIT_CENTER_PAGE](payload) {
        this.paging = payload;
    }
    [_h = Mutations.SET_PROFIT_CENTER_LOAD_PAGE]() {
        this.loadPage = true;
    }
    [_j = Mutations.SET_PROFIT_CENTER_STATUS](payload) {
        this.status = payload.statusProfitCenter;
        this.statusMessage = payload.statusMessageProfitCenter;
    }
    [_k = Mutations.SET_DROPDOWNLIST_PROFIT_CENTER](payload) {
        this.dropdownlistProfitCenter = payload;
    }
    [_l = Mutations.SET_PROFIT_CENTER_SIZE](payload) {
        this.size = payload;
    }
    [_m = Mutations.SET_PROFIT_CENTER_HANDLE_SIZE](payload) {
        this.size = payload;
    }
    [_o = Mutations.SET_PROFIT_CENTER_PAGE_FILTER](payload) {
        this.pageFilter = payload;
    }
    [_p = Mutations.SET_PROFIT_CENTER_WAS_LOAD_QUICK_FILTER](payload) {
        this.wasLoadQuickFilter = payload;
    }
    [_q = Mutations.SET_PROFIT_CENTER_DESC](payload) {
        this.desc = payload;
    }
    [_r = Mutations.SET_PROFIT_CENTER_SEARCH_BY](payload) {
        this.searchBy = payload;
    }
    [_s = Actions.GET_PROFIT_CENTER_LIST]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_PROFIT_CENTER_LOADING, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/budgetcatalog/profitcenterfilter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.page.toString(),
                Size: this.size.toString(),
                profitCenter: this.selectedProfitCenter
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    var _x, _y;
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_PROFIT_CENTER_LIST, ((_x = res.data.result.content) === null || _x === void 0 ? void 0 : _x.data) || []);
                        this.context.commit(Mutations.SET_PROFIT_CENTER_LOAD_PAGE, true);
                        this.context.commit(Mutations.SET_PROFIT_CENTER_PAGE, ((_y = res.data.result.content) === null || _y === void 0 ? void 0 : _y.paging) || {
                            currentPage: 0,
                            totalPages: 0,
                            totalElements: 0,
                            errorRows: 0,
                            readyToUpload: 0
                        });
                        this.context.commit(Mutations.SET_PROFIT_CENTER_LOADING, false);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_PROFIT_CENTER_LOADING, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_t = Actions.GET_PROFIT_CENTER_LIST_ALLDATA]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_PROFIT_CENTER_WAS_LOAD_QUICK_FILTER, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/budgetcatalog/profitcenterfilter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.pageFilter.toString(),
                Size: '20',
                Desc: this.desc,
                SearchBy: this.searchBy,
                profitCenter: this.selectedProfitCenter
            };
            const dataListProfitCenter = [...this.dropdownlistProfitCenter];
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content !== null) {
                            if (res.data.result.content.paging.totalPages === this.pageFilter) {
                                this.context.commit(Mutations.SET_PROFIT_CENTER_WAS_LOAD_QUICK_FILTER, false);
                            }
                            else {
                                this.context.commit(Mutations.SET_PROFIT_CENTER_WAS_LOAD_QUICK_FILTER, true);
                            }
                            res.data.result.content.data.map((data) => {
                                dataListProfitCenter.push({
                                    value: data.profitCenter,
                                    label: data.profitCenter
                                });
                            });
                        }
                        else {
                            this.context.commit(Mutations.SET_PROFIT_CENTER_WAS_LOAD_QUICK_FILTER, false);
                        }
                        // eslint-disable-next-line arrow-body-style
                        const distinctProfitCenter = Array.from(new Set(dataListProfitCenter.map((s) => {
                            return s.value;
                        })))
                            // eslint-disable-next-line arrow-parens
                            .map((label) => {
                            return {
                                value: label,
                                // eslint-disable-next-line arrow-body-style
                                label: dataListProfitCenter.find((s) => s.label === label)
                                    .label
                            };
                        });
                        this.context.commit(Mutations.SET_DROPDOWNLIST_PROFIT_CENTER, distinctProfitCenter);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_PROFIT_CENTER_WAS_LOAD_QUICK_FILTER, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_PROFIT_CENTER_WAS_LOAD_QUICK_FILTER, false);
                    reject(false);
                });
            });
        });
    }
    [_u = Actions.UPDATE_PROFIT_CENTER_SIZE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_PROFIT_CENTER_SIZE, data);
            this.context.commit(Mutations.SET_PROFIT_CENTER_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_PROFIT_CENTER_LIST);
        });
    }
    [_v = Actions.UPDATE_PROFIT_CENTER_PAGE_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_PROFIT_CENTER_PAGE_FILTER, this.pageFilter + 1);
        });
    }
    [_w = Actions.UPDATE_PROFIT_CENTER_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_PROFIT_CENTER_SEARCH_BY, data === '' ? '' : 'profitCenter');
            this.context.commit(Mutations.SET_PROFIT_CENTER_DESC, data);
            this.context.commit(Mutations.SET_PROFIT_CENTER_HANDLE_PAGE, 1);
            this.context.commit(Mutations.SET_DROPDOWNLIST_PROFIT_CENTER, []);
            this.context.dispatch(Actions.GET_PROFIT_CENTER_LIST_ALLDATA);
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ProfitCenterModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ProfitCenterModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ProfitCenterModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ProfitCenterModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ProfitCenterModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ProfitCenterModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ProfitCenterModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ProfitCenterModule.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ProfitCenterModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ProfitCenterModule.prototype, _k, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ProfitCenterModule.prototype, _l, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ProfitCenterModule.prototype, _m, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ProfitCenterModule.prototype, _o, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ProfitCenterModule.prototype, _p, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ProfitCenterModule.prototype, _q, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ProfitCenterModule.prototype, _r, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], ProfitCenterModule.prototype, _s, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], ProfitCenterModule.prototype, _t, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], ProfitCenterModule.prototype, _u, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], ProfitCenterModule.prototype, _v, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], ProfitCenterModule.prototype, _w, null);
ProfitCenterModule = __decorate([
    Module
], ProfitCenterModule);
export default ProfitCenterModule;
